function balanceSelectionTotals(lines) {
  const keys=['calories','protein','carbs','fat'];
  const priced=lines.length>0&&lines.every(line=>Number.isFinite(line.price));
  const completeNutrition=lines.length>0&&lines.every(line=>keys.every(key=>Number.isFinite(line.nutrition?.[key])));
  return {
    priced,
    completeNutrition,
    subtotal:priced?lines.reduce((sum,line)=>sum+line.price*line.quantity,0):null,
    nutrition:completeNutrition?Object.fromEntries(keys.map(key=>[key,lines.reduce((sum,line)=>sum+line.nutrition[key]*line.quantity,0)])):null,
    canAddToBasket:priced&&lines.every(line=>Boolean(line.variantId))
  };
}
function balancePerMealNutrition(nutrition, mealCount) {
  const keys = ['calories','protein','carbs','fat'];
  if (!Number.isSafeInteger(mealCount) || mealCount < 1 || !keys.every(key => Number.isFinite(nutrition?.[key]))) return null;
  return Object.fromEntries(keys.map(key => [key, nutrition[key] / mealCount]));
}
(() => {
  function init() {
    document.querySelectorAll('[data-balance-builder]').forEach(root => {
      if(root.dataset.ready) return;
      root.dataset.ready='true';
      const read = (element, fallback) => {try{return JSON.parse(element?.textContent || '')}catch{return fallback}};
      const labels=read(root.querySelector('[data-labels]'),{});
      const money=new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:root.dataset.currency||'GBP'});
      const nutrients=['calories','protein','carbs','fat'];
      const lines=[];
      const status=root.querySelector('[data-status]');
      const cart=root.querySelector('[data-cart]');
      const mealCount=root.querySelector('[data-meal-count]');
      const displayNutrition=(container,data) => {
        container.replaceChildren();
        nutrients.forEach(key=>{
          const term=document.createElement('dt');term.textContent=labels[key];
          const value=document.createElement('dd');value.textContent=Number.isFinite(data?.[key]) ? Math.round(data[key]*10)/10 + (key==='calories'?' kcal':'g') : '—';
          container.append(term,value);
        });
      };
      let currentNutrition = null;
      const refreshPerMeal = () => {
        const count = mealCount.valueAsNumber;
        const validCount = mealCount.validity.valid && Number.isSafeInteger(count) && count > 0;
        displayNutrition(root.querySelector('[data-meal-nutrition]'), balancePerMealNutrition(currentNutrition, validCount ? count : null));
        const hint = root.querySelector('[data-meal-hint]');
        hint.textContent = !validCount ? labels.meal_count_hint : !currentNutrition ? labels.meal_nutrition_pending : '';
        hint.hidden = validCount && Boolean(currentNutrition);
      };
      mealCount.addEventListener('input', refreshPerMeal);
      const refresh=()=>{
        const list=root.querySelector('[data-lines]');list.replaceChildren();
        root.querySelector('[data-empty]').hidden=lines.length>0;
        lines.forEach((line,index)=>{
          const row=root.querySelector('[data-row]').content.firstElementChild.cloneNode(true);
          row.querySelector('.balance-builder__line-title').textContent=line.title;
          row.querySelector('.balance-builder__line-options').textContent=line.options.join(' · ');
          row.querySelector('[data-quantity]').textContent=line.quantity;
          row.querySelector('[data-line-price]').textContent=Number.isFinite(line.price)?money.format(line.price*line.quantity/100):labels.price_pending;
          row.querySelector('[data-minus]').disabled=line.quantity<=1;
          row.querySelector('[data-minus]').addEventListener('click',()=>{line.quantity=Math.max(1,line.quantity-1);refresh()});
          row.querySelector('[data-plus]').addEventListener('click',()=>{line.quantity=Math.min(999,line.quantity+1);refresh()});
          row.querySelector('[data-remove]').addEventListener('click',()=>{lines.splice(index,1);refresh()});
          list.append(row);
        });
        const totals=balanceSelectionTotals(lines);
        root.querySelector('[data-total]').textContent=totals.priced?money.format(totals.subtotal/100):'—';
        displayNutrition(root.querySelector('[data-total-nutrition]'),totals.nutrition);
        currentNutrition = totals.nutrition;
        refreshPerMeal();
        root.querySelector('[data-hint]').hidden=totals.priced&&totals.completeNutrition;
        cart.disabled=!totals.canAddToBasket;
        root.querySelector('[data-count]').textContent=lines.reduce((sum,line)=>sum+line.quantity,0);
        root.querySelector('[data-mobile-total]').textContent=totals.priced?money.format(totals.subtotal/100):'—';
      };
      root.querySelectorAll('[data-category]').forEach(button=>button.addEventListener('click',()=>{
        root.querySelectorAll('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        root.querySelectorAll('[data-category-panel]').forEach(panel=>panel.hidden=panel.dataset.categoryPanel!==button.dataset.category);
      }));
      const meatPanel = root.querySelector('[data-category-panel="meats"]');
      if (meatPanel) {
        const meatButtons = [...meatPanel.querySelectorAll('[data-meat-type]')];
        const meatCards = [...meatPanel.querySelectorAll('[data-meat-card]')];
        const showMeat = type => {
          meatButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.meatType === type)));
          meatCards.forEach(card => { card.hidden = card.dataset.meatCard !== type; });
          meatPanel.querySelector('[data-meat-empty]').hidden = meatCards.some(card => !card.hidden);
        };
        meatButtons.forEach(button => button.addEventListener('click', () => showMeat(button.dataset.meatType)));
        showMeat('chicken');
      }
      root.querySelectorAll('[data-ingredient]').forEach(card=>{
        const variants=read(card.querySelector('[data-variants]'),[]);
        const nutrition=read(card.querySelector('[data-nutrition]'),{});
        const choices=[...card.querySelectorAll('[data-choice]')];
        const selected=()=>variants.find(v=>v.options.every((option,i)=>option===choices[i]?.value));
        const update=()=>{
          const variant=selected();const data=nutrition[String(variant?.id)];
          card.querySelector('[data-price]').textContent=variant?money.format(variant.price/100):labels.price_pending;
          displayNutrition(card.querySelector('[data-card-nutrition]'),data);
          card.querySelector('[data-add]').disabled=variants.length>0&&(!variant||!variant.available);
          card.querySelector('[data-add]').textContent=variant&&!variant.available?labels.sold_out:labels.add;
        };
        choices.forEach(choice=>choice.addEventListener('change',update));update();
        card.querySelector('[data-add]').addEventListener('click',()=>{
          const variant=selected();const options=choices.map(c=>c.value);
          const key=card.dataset.ingredient+'|'+options.join('|');
          const existing=lines.find(l=>l.key===key);
          if(existing)existing.quantity=Math.min(existing.quantity+1,999);
          else lines.push({key,title:card.dataset.title,options,quantity:1,price:variant?.price,variantId:variant?.id,nutrition:nutrition[String(variant?.id)]});
          refresh();status.textContent=labels.added;
        });
      });
      root.querySelector('[data-review]').addEventListener('click',()=>root.querySelector('.balance-builder__summary').scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
      cart.addEventListener('click',async()=>{
        if(cart.disabled)return;
        cart.disabled=true;cart.textContent=labels.busy;
        try {
          const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:lines.map(l=>({id:l.variantId,quantity:l.quantity}))})});
          if(!response.ok)throw new Error('cart');
          window.location.assign((window.Shopify?.routes?.root||'/')+'cart');
        }catch{status.textContent=labels.error;cart.textContent=labels.cart;refresh()}
      });
      refresh();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
